import script from "./FacebookRightsAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./FacebookRightsAlert.vue?vue&type=script&lang=ts&setup=true"

import "./FacebookRightsAlert.vue?vue&type=style&index=0&id=20384126&lang=sass"

const __exports__ = script;

export default __exports__